import { render, staticRenderFns } from "./AvatarAndNotifications.vue?vue&type=template&id=a57d262a&scoped=true&"
import script from "./AvatarAndNotifications.vue?vue&type=script&lang=js&"
export * from "./AvatarAndNotifications.vue?vue&type=script&lang=js&"
import style0 from "./AvatarAndNotifications.vue?vue&type=style&index=0&id=a57d262a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a57d262a",
  null
  
)

export default component.exports